import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var PhonebookContact = /** @class */ (function (_super) {
    tslib_1.__extends(PhonebookContact, _super);
    function PhonebookContact(_id, firstName, lastName, email, type, notes, updatedAt, createdAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.firstName = firstName;
        _this.lastName = lastName;
        _this.email = email;
        _this.type = type;
        _this.notes = notes;
        _this.updatedAt = updatedAt;
        _this.createdAt = createdAt;
        _this.setRequiredFields([
            '_id',
            'firstName',
            'lastName',
            'email',
            'createdAt',
        ]);
        return _this;
    }
    return PhonebookContact;
}(BaseModel));
export { PhonebookContact };
